import { createAction } from '@reduxjs/toolkit';

import type { Blueprint } from 'js/src/client/types.gen';
import { ACTIONS } from 'js/src/data/blueprints/blueprints-types';

export const pushBlueprint = createAction<{
    blueprint: Blueprint;
}>(ACTIONS.PUSH_BLUEPRINT);

export const pushBlueprints = createAction<{
    blueprints: Blueprint[];
}>(ACTIONS.PUSH_BLUEPRINTS);

export const clearBlueprints = createAction(ACTIONS.CLEAR_BLUEPRINTS);

export const removeBlueprint = createAction<{
    blueprintId: number;
}>(ACTIONS.REMOVE_BLUEPRINT);

export const setBlueprintName = createAction<{
    name: string;
    blueprintId: number;
}>(ACTIONS.SET_BLUEPRINT_NAME);

export const setBlueprintsLoading = createAction<{
    loading: boolean;
}>(ACTIONS.SET_BLUEPRINTS_LOADING);
